import { SetActiveTab } from "../../../../../../shared/scripts/tab-utilities";
import { ISiteInfo } from "../../../scripts/data-completeness.page";
import { SamplesDialog } from "../scripts/samples.dialog";
import { SamplesEvent } from "../scripts/samples.entities";
import { SamplesLookup } from "../scripts/samples.lookup";
import { SamplesSummarySeries } from "./samples-summary.entities";
import { VisitLookup } from "../../visits-tab/scripts/visits.lookup";

var Highcharts = require('highcharts/highcharts');

export class SamplesSummaryView {

    samplesSummaryChart: any;
    siteSummaryChart: any;
    samplesReasonsChart: any;
    siteReasonsChart: any;

    selectedGrouping: string; //sample, site
    selectedData: string; //status
    drillBackUpSampleData: any = null;
    drillBackUpVisitData: any = null;

    constructor() {
        this.selectedGrouping = "samples";
        this.selectedData = "status";
    }

    UpdateData(visitSeries: SamplesSummarySeries[], siteSeries: SamplesSummarySeries[], samplesSeries: SamplesSummarySeries[]): void {
        //console.log("Summary View - Data Received", {
        //    byVisit: visitSeries.length,
        //    bySite: siteSeries.length,
        //    bySamples: samplesSeries.length,
        //    visitLabels: visitSeries.map(s => s.name),
        //    siteLabels: siteSeries.map(s => s.name),
        //    samplesLabels: samplesSeries.map(s => s.name)
        //});

        samplesSeries.sort((a, b) => a.sortValue - b.sortValue);
        visitSeries.sort((a, b) => a.sortValue - b.sortValue);
        this.updateChart('samples-byvisit-summary-status-chart', visitSeries, SamplesLookup.GetSamplesStatusGroups() , "Timepoints");
        this.updateChart('samples-bysite-summary-status-chart', siteSeries, SamplesLookup.GetSamplesStatusGroups(), "Sites");
        this.updateChart('samples-bysamples-summary-status-chart', samplesSeries, SamplesLookup.GetSamplesStatusGroups(), "Samples");
    }

    private updateChart(chartId: string, data: SamplesSummarySeries[], groupedStatus: { label: string; ids: number[] }[], axisLabel: string): void {
        let series: any[] = [];
        let categories: string[] = [];
        let samples: SamplesEvent[] = [];

        //samplesStatusIds.forEach((statusId: number) => {

        //    let seriesData: any[] = new Array<any>(data.length).fill(0);
        //    for (let i = 0; i < data.length; ++i) {

        //        if (!categories.includes(data[i].name)) { categories.push(data[i].name); }
        //        if (data[i].samplesByStatus.has(statusId)) {
        //            seriesData[i] = { y: data[i].samplesByStatus.get(statusId).length, samples: data[i].samplesByStatus.get(statusId) };
        //        }
        //    }

        //    series.push({
        //        name: SamplesLookup.GetSamplesSatusColumn(statusId),
        //        data: seriesData,
        //        colorIndex: SamplesLookup.GetSamplesColorIndex(statusId),
        //        statusId: statusId
        //    });
        //});
        groupedStatus.forEach((statusGroup) => {
            let seriesData: any[] = new Array<any>(data.length).fill(0);
            for (let i = 0; i < data.length; ++i) {
                if (!categories.includes(data[i].name)) {
                    categories.push(data[i].name);
                }
                let combinedSamples: SamplesEvent[] = [];
                for (const statusId of statusGroup.ids) {
                    if (data[i].samplesByStatus.has(statusId)) {
                        combinedSamples = combinedSamples.concat(data[i].samplesByStatus.get(statusId));
                    }
                }
                if (combinedSamples.length > 0) {
                    seriesData[i] = {
                        y: combinedSamples.length,
                        samples: combinedSamples
                    };
                }
                //console.log(`Group "${statusGroup.label}" - ${data[i].name} has:`);
                //console.log(combinedSamples.map(s => s.SamplesStatusId));
            }
            series.push({
                name: statusGroup.label,
                data: seriesData,
                colorIndex: SamplesLookup.GetSamplesColorIndex(statusGroup.ids[0]),
                statusId: statusGroup.ids[0]
            });

        }); 

        this.initializeBarChart(chartId, categories, series);
    }

    private initializeBarChart(chartId: string, categories: string[], data: any[]): any {
        let axisLabel: string;
        if (chartId === 'samples-bysamples-summary-status-chart') {
            axisLabel = 'Biospecimen Type'
            this.drillBackUpSampleData = { chartId, axisLabel, categories, data };
        } else if (chartId === 'samples-byvisit-summary-status-chart') {
            axisLabel = 'Visit'
            this.drillBackUpVisitData = { chartId, axisLabel, categories, data };
        }

        const self = this;
        let chart: any = Highcharts.chart(chartId, {
            chart: {
                type: 'bar',
                styledMode: true,
                height: 100 + (45 * categories.length)
            },
            credits: { enabled: false },
            title: { text: null },
            xAxis: {
                type: 'category',
                categories: categories,
                min: 0,
                max: categories.length - 1,
                title: { text: axisLabel },
                tickInterval: 1,
                tickLength: 0,
                labels: {
                    useHTML: true,
                    formatter: function () {
                        if (chartId === 'samples-bysamples-summary-status-chart' || chartId === 'samples-byvisit-summary-status-chart') {
                            return `<span class="category-label drilldown-label" data-category="${this.value}" data-chartid="${chartId}">${this.value}</span>`;
                        } else {
                            return this.value;
                        }
                    }
                }
            },
            yAxis: {
                min: 0,
                endOnTick: false, // helps with cropping data labels
                maxPadding: 0.2, // larger value has more space for data labels (default is 0.05)
                reversedStacks: false,
                title: { text: 'Timepoint Count' },
                labels: {
                    formatter: function () {
                        return Highcharts.numberFormat(this.value, 0, '.', ',');
                    }
                },
                stackLabels: {
                    enabled: true,
                    formatter: function () {
                        return Highcharts.numberFormat(this.total, 0, '.', ',');
                    },
                    inside: false, //label issues
                    verticalAlign: 'middle',
                }
            },
            legend: {
                //    enabled: false,
                    reversed: false,
                //    title: {
                //        text: '<div style="font-size: 10px; color: #666; font-weight: normal; width: 100%; text-align: center">Visits</span>',
                //    },
                align: 'center',
                verticalAlign: 'top',
            },
            plotOptions: {
                series: {
                    stacking: 'normal',
                    point: {
                        events: {
                            click: function () {
                                const samples = this.options.samples || [];
                                SamplesDialog.ShowDialog(samples);
                            }
                        }
                    },
                },
                bar: {
                    pointWidth: 25,
                    pointPadding: 0.1,
                    //groupPadding: 0.2,
                    borderWidth: 0,
                    dataLabels: {
                        enabled: true,
                        formatter: function () {
                            if (this.y == 0) return null;
                            else {
                                let label: string = Highcharts.numberFormat(this.y, 0, '.', ',');
                                if (this.point.shapeArgs.height <= (label.length * 10)) return null;
                                else return label;
                            }
                        },
                        verticalAlign: 'middle',
                        y: 2
                    },
                },
            },
            series: data,
        });
        document.querySelectorAll('.drilldown-label').forEach((label) => {
            label.addEventListener('click', function (event) {
                event.stopPropagation();
                const categoryName = (event.target as HTMLElement).dataset.category;
                const categoryIndex = categories.indexOf(categoryName);

                if (categoryIndex === -1) {
                    console.warn(`${categoryName} not found`);
                    return;
                }


                const seriesData = chart.series.map(series => ({
                    name: series.name,
                    data: series.data[categoryIndex].options
                }));

                self.updateChartForDrilldown(seriesData, chartId, categoryName);
            });
        });

        // console.log('Chart initialized:', chart);
        return chart;
    }

    SetView(newView: string): void {
        if (!newView.startsWith("samples-summary")) { return; }
        else if (newView != "samples-summary") { //new within-summary view
            if (newView.includes("byvisit")) { this.selectedGrouping = "visit"; }
            else if (newView.includes("bysite")) { this.selectedGrouping = "site"; }
            else if (newView.includes("bysample")) { this.selectedGrouping = "samples"; }

            if (newView.includes("bystatus")) { this.selectedData = "status"; }
        }

        if (this.selectedGrouping == "visit" && this.selectedData == "status") { SetActiveTab("samples-summary-tabs", "content-summary-samples-byvisit-status"); }
        else if (this.selectedGrouping == "site" && this.selectedData == "status") { SetActiveTab("samples-summary-tabs", "content-summary-samples-bysite-status"); }
        else if (this.selectedGrouping == "samples" && this.selectedData == "status") { SetActiveTab("samples-summary-tabs", "content-summary-samples-bysamples-status"); }

        // console.log('View updated:', { selectedGrouping: this.selectedGrouping, selectedData: this.selectedData });
    }

    private updateChartForDrilldown(data, chartId: string, nameOfItem): void {
        let drilldownData: Map<number, Map<number, number>> = new Map();
        //console.log(data);
        const self = this;
        const statusGroup = SamplesLookup.GetSamplesStatusGroups();
        const groupLabelToIds = new Map<string, number[]>();
        statusGroup.forEach(g => groupLabelToIds.set(g.label, g.ids));

        if (chartId === 'samples-bysamples-summary-status-chart') {
            data.forEach((series) => {
                if (!series.data || !series.data.samples || series.data.samples.length === 0) {
                    return;
                }
                const samples = series.data.samples;

                samples.forEach((event: any) => {
                    if (!drilldownData.has(event.VisitAbb)) {
                        drilldownData.set(event.VisitAbb, new Map());
                    }

                    let statusCounts = drilldownData.get(event.VisitAbb)!;
                    statusCounts.set(
                        event.SamplesStatusId,
                        (statusCounts.get(event.SamplesStatusId) || 0) + 1
                    );
                });
            });

            let categories: string[] = [];
            let seriesMap: Map<string, { name: string; data: { y: number, samples: SamplesEvent[] }[], colorIndex: number }> = new Map();

            statusGroup.forEach(group => {
                if (!seriesMap.has(group.label)) {
                    const colorIndex = SamplesLookup.GetSamplesColorIndex(group.ids[0]);
                    seriesMap.set(group.label, { name: group.label, data: [], colorIndex: colorIndex });
                }
            })
            let timepointList: { id: any, name: string }[] = [];
            drilldownData.forEach((_, timepointId) => {
                const timepointName = VisitLookup.GetVisitMasterColumn(timepointId);
                timepointList.push({ id: timepointId, name: timepointName });
            });
            timepointList.sort((a, b) => VisitLookup.GetVisitMasterOrdering(a.id) - VisitLookup.GetVisitMasterOrdering(b.id));
            timepointList.forEach(tp => {
                categories.push(tp.name);
                const statusCounts = drilldownData.get(tp.id)!;
                seriesMap.forEach((series, groupLabel) => {
                    const groupIds = groupLabelToIds.get(groupLabel) || [];
                    let total = 0;
                    const statusCountsForGroup = groupIds.map(id => statusCounts.get(id) || 0);
                    total = statusCountsForGroup.reduce((a, b) => a + b, 0);
                    const combinedSamples = data
                        .flatMap(d => d.data.samples || [])
                        .filter((e: SamplesEvent) =>
                            e.VisitAbb === tp.id && groupIds.includes(e.SamplesStatusId)
                        );

                    series.data.push({
                        y: total,
                        samples: combinedSamples
                    });
                });
            });

            const series = Array.from(seriesMap.values());

            console.log('Drill', drilldownData);
            Highcharts.chart('samples-bysamples-summary-status-chart', {
                chart: {
                    type: 'bar',
                    styledMode: true,
                    height: 200 + (45 * categories.length),
                    events: {
                        load: function () {
                            $('#samples-bysamples-summary-status-chart').prepend(
                                `<div class="chart-header">
                                <button class='btn btn-outline-secondary chart-drillup-btn mr-2 ml-2'><i class="fas fa-undo"></i></button>
                                <span class="drilldown-title">Timepoints for ${nameOfItem}</span>
                                </div>`
                            );
                            $('#samples-bysamples-summary-status-chart').find(".chart-drillup-btn").on('click', () => {
                                self.restoreOriginalChart(self.drillBackUpSampleData);
                            });
                        }
                    },
                },
                title: { text: null },
                credits: { enabled: false },
                xAxis: {
                    categories: categories,
                    title: {
                        text: 'Timepoints'
                    },
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: 'Count'
                    },
                    stackLabels: {
                        enabled: true,
                        style: {
                            fontWeight: 'bold',
                            color: 'gray'
                        },
                        formatter: function () {
                            return this.total;
                        }
                    }
                },
                legend: {
                    align: 'center',
                    verticalAlign: 'top',
                    reversed: true,
                },
                tooltip: {
                    headerFormat: '<b>{point.x}</b><br/>',
                    pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
                },
                plotOptions: {
                    series: {
                        stacking: 'normal',
                        dataLabels: {
                            enabled: true
                        },
                        point: {
                            events: {
                                click: function () {
                                    const samples = this.options.samples || [];
                                    SamplesDialog.ShowDialog(samples);
                                }
                            }
                        }
                    },
                    bar: {
                        pointWidth: 25,
                        pointPadding: 0.1,
                        //groupPadding: 0.2,
                        borderWidth: 0,
                        dataLabels: {
                            enabled: true,
                            formatter: function () {
                                if (this.y == 0) return null;
                                else {
                                    let label: string = Highcharts.numberFormat(this.y, 0, '.', ',');
                                    if (this.point.shapeArgs.height <= (label.length * 10)) return null;
                                    else return label;
                                }
                            },
                            verticalAlign: 'middle',
                            y: 2
                        },
                    },
                },
                series: series.reverse(),

            });
        }
        else if (chartId == 'samples-byvisit-summary-status-chart') {
            data.forEach((series) => {
                if (!series.data || !series.data.samples || series.data.samples.length === 0) {
                    return;
                }
                const samples = series.data.samples;

                samples.forEach((event: any) => {
                    if (!drilldownData.has(event.BiospecId)) {
                        drilldownData.set(event.BiospecId, new Map());
                    }

                    let statusCounts = drilldownData.get(event.BiospecId)!;
                    statusCounts.set(
                        event.SamplesStatusId,
                        (statusCounts.get(event.SamplesStatusId) || 0) + 1
                    );
                });
            });


            let categories: string[] = [];
            let seriesMap: Map<string, { name: string; data: { y: number, samples: SamplesEvent[] }[], colorIndex: number }> = new Map();

            statusGroup.forEach(group => {
                if (!seriesMap.has(group.label)) {
                    const colorIndex = SamplesLookup.GetSamplesColorIndex(group.ids[0]);
                    seriesMap.set(group.label, { name: group.label, data: [], colorIndex: colorIndex });
                }
            })
            //drilldownData.forEach((statusCounts, sampleId) => {
            //    //const timepointName = SamplesLookup.GetVisitFullNameColumn(timepointId);
            //    const sampleName = SamplesLookup.GetSampleColumn(sampleId);
            //    categories.push(`${sampleName}`);

            //    seriesMap.forEach((series, groupLabel) => {
            //        const groupIds = groupLabelToIds.get(groupLabel) || [];
            //        let total = 0;
            //        const statusCountsForGroup = groupIds.map(id => statusCounts.get(id) || 0);
            //        total = statusCountsForGroup.reduce((a, b) => a + b, 0);
            //        const combinedSamples = data
            //            .flatMap(d => d.data.samples || [])
            //            .filter((e: SamplesEvent) =>
            //                e.BiospecId === sampleId && groupIds.includes(e.SamplesStatusId)
            //        );

            //        series.data.push({
            //            y: total,
            //            samples: combinedSamples
            //        });
            //    });
            //});

            let sampleList: { id: any, name: string }[] = [];
            drilldownData.forEach((_, sampleId) => {
                const sampleName = SamplesLookup.GetSampleColumn(sampleId);
                sampleList.push({ id: sampleId, name: sampleName });
            });
            sampleList.sort((a, b) => a.name.localeCompare(b.name));
            sampleList.forEach(sample => {
                categories.push(sample.name);
                const statusCounts = drilldownData.get(sample.id)!;
                seriesMap.forEach((series, groupLabel) => {
                    const groupIds = groupLabelToIds.get(groupLabel) || [];
                    let total = 0;
                    const statusCountsForGroup = groupIds.map(id => statusCounts.get(id) || 0);
                    total = statusCountsForGroup.reduce((a, b) => a + b, 0);
                    const combinedSamples = data
                        .flatMap(d => d.data.samples || [])
                        .filter((e: SamplesEvent) =>
                            e.BiospecId === sample.id && groupIds.includes(e.SamplesStatusId)
                        );

                    series.data.push({
                        y: total,
                        samples: combinedSamples
                    });
                });
            });

            const series = Array.from(seriesMap.values());

            console.log('Drill', drilldownData);
            Highcharts.chart('samples-byvisit-summary-status-chart', {
                chart: {
                    type: 'bar',
                    styledMode: true,
                    height: 200 + (45 * categories.length),
                    events: {
                        load: function () {
                            $('#samples-byvisit-summary-status-chart').prepend(
                                `<div class="chart-header">
                                <button class='btn btn-outline-secondary chart-drillup-btn mr-2 ml-2'><i class="fas fa-undo"></i></button>
                                <span class="drilldown-title">Samples for ${nameOfItem}</span>
                                </div>`
                            );
                            $('#samples-byvisit-summary-status-chart').find(".chart-drillup-btn").on('click', () => {
                                self.restoreOriginalChart(self.drillBackUpVisitData);
                            });
                        }
                    },
                },
                title: { text: null },
                credits: { enabled: false },
                xAxis: {
                    categories: categories,
                    title: {
                        text: 'Biospecimen Type'
                    },
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: 'Count'
                    },
                    stackLabels: {
                        enabled: true,
                        style: {
                            fontWeight: 'bold',
                            color: 'gray'
                        },
                        formatter: function () {
                            return this.total;
                        }
                    }
                },
                legend: {                                                                                                                                                                                                                                    
                    align: 'center',
                    verticalAlign: 'top',
                    reversed: true,
                },
                tooltip: {
                    headerFormat: '<b>{point.x}</b><br/>',
                    pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
                },
                plotOptions: {
                    series: {
                        stacking: 'normal',
                        dataLabels: {
                            enabled: true
                        },
                        point: {
                            events: {
                                click: function () {
                                    const samples = this.options.samples || [];
                                    //console.log("Samples for Dialog box: ", samples);
                                    SamplesDialog.ShowDialog(samples);
                                }
                            }
                        }
                    },
                    bar: {
                        pointWidth: 25,
                        pointPadding: 0.1,
                        //groupPadding: 0.2,
                        borderWidth: 0,
                        dataLabels: {
                            enabled: true,
                            formatter: function () {
                                if (this.y == 0) return null;
                                else {
                                    let label: string = Highcharts.numberFormat(this.y, 0, '.', ',');
                                    if (this.point.shapeArgs.height <= (label.length * 10)) return null;
                                    else return label;
                                }
                            },
                            verticalAlign: 'middle',
                            y: 2
                        },
                    },
                },
                series: series.reverse(),
            });

        }
    }

    private restoreOriginalChart(chartData: { chartId: string, axisLabel: string, categories: string[], data: any[] }): void {
        const chartContainer = Highcharts.charts.find(chart => chart?.renderTo.id === chartData.chartId);


        if (chartContainer) {
            chartContainer.destroy();
        }


        if (chartData) {
            setTimeout(() => {
                this.initializeBarChart(
                    chartData.chartId,
                    //chartData.axisLabel,
                    chartData.categories,
                    chartData.data
                );
            }, 50);
        }
    }
}